<template>
  <div id="chart_table">
    <el-table
      element-loading-background="rgba(255, 255, 255, 0.8)!important"
      class="table-responsive table-flush mt-4"
      header-row-class-name="thead-light"
      row-key="orgLureId"
      :data="data"
      >
        <el-table-column :width="column.width || 'auto'"
                         v-for="column in columns"
                         :key="column.prop"
                         :label="column.label"
                         :prop="column.prop"
                         :sortable="column.sortable">
          <template v-slot="{ row, $index }">
            <template v-if="column.editable && $index === editingIndex">
              <el-input-number v-if="column.editType === 'number'"
                               v-model="editedData[column.prop]"
                               controls-position="right"
                               size="small"
                               :style="{ width: '100px'}"
                               step-strictly
                               :min="0"
                               />
              <el-date-picker v-else-if="column.editType === 'datepicker'"
                              v-model="editedData[column.prop]"
                              :style="{ width: '150px'}"
                              value-format="yyyy-MM-dd"
                              format="dd/MM/yyyy"
                              type="date"
                              placeholder="Due date"></el-date-picker>
              <el-input v-else v-model="editedData[column.prop]"></el-input>
            </template>
           
            <template v-else-if="column.prop === 'isTrial'">
              <span :class="row[column.prop] ? 'badge badge-success' : 'badge badge-warning'">{{row.isTrial ? 'yes' : 'no'}}</span>
            </template>
            <template v-else>
              {{ row[column.prop] }}
            </template>
          </template>
        </el-table-column>

        <el-table-column v-if="editable" min-width="100px" label="" align="center" class="pr-0">
          <template v-slot="{ row, $index }">
            <el-button-group v-if="$index === editingIndex">
              <el-button @click="cancelEdit">
                <i class="fas fa-times"></i>
              </el-button>
              <el-button @click="saveEdit">
                <i class="fas fa-check"></i>
              </el-button>
            </el-button-group>
            <div v-else>
              <base-button class="btn-sm" @click="startEditing($index)">
                <i class="fas fa-pencil-alt"></i>
              </base-button>
              <base-button class="btn-sm" @click="toggleShippingModal(row)">
                <i class="fas fa fa-shipping-fast"></i>
              </base-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <modal :show.sync="showShippingModal">
        <h6 slot="header" class="modal-title">Ship lure</h6>
        <el-form>
          <el-form-item>        
            <el-date-picker v-model="editedShipDate"
                            :default-value="new Date()"
                            value-format="yyyy-MM-dd"
                            format="dd/MM/yyyy"
                            placeholder="Shipped on"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="createNew">Create next shipment</el-checkbox>
          </el-form-item>
          <base-alert>Checking this box will automatically create the next shipment, based on the lure frequency. Quantities and comments will remain the same.</base-alert>
          <el-form-item>
            <el-checkbox v-model="addBatteries">Include batteries</el-checkbox>
          </el-form-item>
          <div v-if="addBatteries">
            <el-form-item label="Battery Quantity">
              <el-input-number v-model="batteryQuantity"
                              size="small"
                              step-strictly
                              :min="0" />
            </el-form-item>
            <el-form-item label="Battery Comments">
              <el-input type="textarea"
                        :rows="2"
                        placeholder="Type your comments here"
                        v-model="batteryComments" />
            </el-form-item>
          </div>
        </el-form>
        <template slot="footer">
          <base-button type="blank" @click="showShippingModal = false; editedData = null">Cancel</base-button>
          <base-button type="primary" :disabled="editedShipDate == null" @click="ship">Mark as shipped</base-button>
        </template>
      </modal>
    </div>
  </template>
<script>

import { Checkbox, DatePicker, Dropdown, DropdownItem, DropdownMenu, Form, FormItem, Table, TableColumn } from 'element-ui';
import moment from 'moment';

export default {
  name: 'org-parts-table',
  props: {
    editable: {
      type: Boolean,
      default: false,
      description: 'Editable'
    },
    columns: {
      type: Array,
      default () {
        return [{
          prop: 'name',
          label: 'Name'
        }]
      },
      description: 'Columns'
    },
    data: {
      type: Array,
      default: [],
      description: 'Table data'
    }
  },
  components: {
    [Checkbox.name]: Checkbox,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [DatePicker.name]: DatePicker,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      createNew: false,
      editingIndex: -1,
      editedData: {},
      editedShipDate: null,
      shippedItem: null,
      showShippingModal: false,
      addBatteries: false,
      batteryQuantity: 0,
      batteryComments: '',
      batteryShipDate: null
    };
  },
  methods: {
    cancelEdit() {
      this.editingIndex = -1;
    },
    getClassForDate: function(date) {
      let className = '';
      if (!this.columns.some(column => column.prop === 'lureShipDate') && !this.columns.some(column => column.prop === 'batteryShipDate')) {
        className = 'badge ';
        const momentDate = moment.unix(date);
        if (momentDate.isSameOrAfter(moment().add(4, 'weeks'), 'day')) {
          className += 'badge-success';
        } else if (momentDate.isSameOrAfter(moment().add(2, 'weeks'), 'day')) {
          className += 'badge-yellow';
        } else if (momentDate.isSameOrAfter(moment().add(1, 'weeks'), 'day')) {
          className += 'badge-warning';
        } else {
          className += 'badge-danger';
        }
      }
      return className;
    },
    saveEdit() {
      this.$emit('save-edited-lure', { lure: this.editedData });
      this.editingIndex = -1;
      this.editedData = {};
    },
    ship() {
      this.showShippingModal = false;
      this.$emit('loading', true);
      const payload = {};
      
      payload.lure = this.shippedItem;
      payload.createNew = this.createNew;
      if (this.editedShipDate) {
        payload.lure.lureShipDate = this.editedShipDate
      }

      if(this.batteryQuantity > 0) {
        this.shipBattery();
      }
      this.$emit('save-edited-lure', payload);
    },
    shipBattery() {
      const payload = {};
      payload.batteryShipDate = this.editedShipDate;
      payload.batteryQuantity = this.batteryQuantity;
      payload.batteryComments = this.batteryComments;
      this.$emit('save-edited-lure', payload);
    },
    startEditing(index) {
      this.editingIndex = index;
      this.editedData = this.data[index];
    },
    toggleShippingModal: function(item) {
      this.shippedItem = item;
      this.showShippingModal = true;
    }
  }
}
</script>

<style scoped>
.badge-yellow {
  background: #fdda0d;
}
</style>